import React, { useContext } from 'react';

import { Popover } from 'antd';

import { useLayoutContext } from '@contexts/LayoutContext';

import { NavMenu, NwNavIcon } from '@components/_LayoutComponents/Header/NwHeaderUI';

import { getNavClassName, getNavMenuMode } from './NwNavUtils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const NwNavBarAccounting = ({
    allLogs,
    createNewItemMenu,
    current,
    drawer,
    handleChangeOpenKeys,
    handleClick,
    isLoaded,
    isOpen,
    lastSeenMenu,
    openKeys,
}) => {
    // const managementClientsReportsAllowed = useUserPermission('ViewManagementClientsReports');
    // const managementModelsReportsAllowed = useUserPermission('ViewManagementModelsReports');
    // const managementDepartmentsReportsAllowed = useUserPermission('ViewManagementDepartmentsReports');
    // const managementBookersReportsAllowed = useUserPermission('ViewManagementBookersReports');
    // TEMP: riattivare permessi
    const managementClientsReportsAllowed = true;
    const managementModelsReportsAllowed = true;
    //const managementDepartmentsReportsAllowed = true;
    const managementBookersReportsAllowed = true;

    const balanceReportAllowed = true;

    const layoutContext = useLayoutContext();
    const { breakpoints } = layoutContext;
    const { modelLogs, customerLogs, statementLogs } = allLogs;

    const navItems = [
        { key: '/accounting', label: 'Dashboard', disabled: !isLoaded },
        {
            //key: "/accounting-jobs",
            popupClassName: 'main-nav-submenu',
            disabled: !isLoaded,
            label: 'Billing',
            children: [
                {
                    type: 'group',
                    //key: "/menu-tools-models",
                    label: (
                        <span className="submenu-title-wrapper">
                            <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />
                            Create Invoices
                        </span>
                    ),
                    children: [
                        { key: '/billing/projects', label: 'Jobs / Projects', disabled: !isLoaded },
                        { key: '/billing/expenses', label: 'Model Expenses', disabled: !isLoaded },
                        { key: '/billing/commissions', label: 'Commissions As Mother Agency', disabled: !isLoaded },
                        // { key: '/billing/commissions-test', label: 'Commissions As Moth. Ag. (TEST)', disabled: !isLoaded },
                    ],
                },
            ],
        },
        {
            key: '/menu-invoice',
            label: 'Invoices',
            popupClassName: !isOpen('/menu-invoice')
                ? 'main-nav-submenu menu-disabled'
                : 'main-nav-submenu menu-double',
            disabled: !isLoaded,
            onTitleClick: () => handleClick({ key: '/invoices' }),
            children: [
                lastSeenMenu(statementLogs, 'invoice-drawer', 'no statements', 'customerName'),
                {
                    type: 'group',
                    key: `/menu-tools-projects`,
                    label: (
                        <span className="submenu-title-wrapper">
                            <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />
                            Tools
                        </span>
                    ),
                    children: [
                        {
                            key: '/invoices',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['clipboard-list-check']} />
                                    Invoices Search
                                </div>
                            ),
                        },
                        {
                            key: '/accounting-reports/invoices',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['square-poll-vertical']} />
                                    Invoices Report
                                </div>
                            ),
                        },
                    ],
                },
                createNewItemMenu('Statement'),
            ],
        },
        {
            key: 'Statements',
            disabled: !isLoaded,
            label: 'Statements',
            popupClassName: 'main-nav-submenu',
            children: [
                {
                    key: '/statements/search',
                    label: 'Statements Search',
                },
                {
                    key: '/balance-report/models',
                    disabled: !balanceReportAllowed,
                    label: balanceReportAllowed ? (
                        'Models Balance Report'
                    ) : (
                        <Popover
                            zIndex={1050}
                            content="Your current Netwalk profile is not allowed to access this section"
                        >
                            <div style={{ opacity: 0.4 }}>
                                <NwNavIcon icon={byPrefixAndName.fasl['ban']} />
                                &nbsp;Models Balance Report
                            </div>
                        </Popover>
                    ),
                },
                {
                    key: '/balance-report/agencies',
                    disabled: !balanceReportAllowed,
                    label: balanceReportAllowed ? (
                        'Agencies Balance Report'
                    ) : (
                        <Popover
                            zIndex={1050}
                            content="Your current Netwalk profile is not allowed to access this section"
                        >
                            <div style={{ opacity: 0.4 }}>
                                <NwNavIcon icon={byPrefixAndName.fasl['ban']} />
                                &nbsp;Models Balance Report
                            </div>
                        </Popover>
                    ),
                },
                {
                    key: '/payments/models',
                    label: 'Models Payments',
                },
                {
                    key: '/payments/agencies',
                    label: 'Agencies Payments',
                },
                {
                    key: '/massive-expenses',
                    label: 'Massive Expenses',
                },
            ],
        },
        {
            label: 'Reports',
            disabled: !isLoaded,
            popupClassName: 'main-nav-submenu',
            children: [
                {
                    key: '/accounting-reports/clients',
                    disabled: !managementClientsReportsAllowed,
                    label: managementClientsReportsAllowed ? (
                        'On Clients'
                    ) : (
                        <Popover
                            zIndex={1050}
                            content="Your current Netwalk profile is not allowed to access this section"
                        >
                            <div style={{ opacity: 0.4 }}>
                                <NwNavIcon icon={byPrefixAndName.fasl['ban']} />
                                &nbsp;On Clients
                            </div>
                        </Popover>
                    ),
                },
                {
                    key: '/accounting-reports/models',
                    disabled: !managementModelsReportsAllowed,
                    label: managementModelsReportsAllowed ? (
                        'On Models'
                    ) : (
                        <Popover
                            zIndex={1050}
                            content="Your current Netwalk profile is not allowed to access this section"
                        >
                            <div style={{ opacity: 0.4 }}>
                                <NwNavIcon icon={byPrefixAndName.fasl['ban']} />
                                &nbsp;On Models
                            </div>
                        </Popover>
                    ),
                },
                {
                    key: '/accounting-reports/bookers',
                    disabled: !managementBookersReportsAllowed,
                    label: managementBookersReportsAllowed ? (
                        'On Bookers'
                    ) : (
                        <Popover
                            zIndex={1050}
                            content="Your current Netwalk profile is not allowed to access this section"
                        >
                            <div style={{ opacity: 0.4 }}>
                                <NwNavIcon icon={byPrefixAndName.fasl['ban']} />
                                &nbsp;On Bookers
                            </div>
                        </Popover>
                    ),
                },
                {
                    key: '/accounting-reports/comm-as-moth-ag',
                    label: 'On M.A.C. (receivable)',
                },
                {
                    key: '/accounting-reports/mother-agency-commissions',
                    label: 'On M.A.C. (payable)',
                },
                {
                    key: '/accounting-reports/work-dates',
                    label: 'On Work Dates',
                },
            ],
        },
        // {
        //     key: '/accounting/models',
        //     label: 'Models',
        //     popupClassName: 'main-nav-submenu',
        //     disabled: !isLoaded,
        //     onTitleClick: () => handleClick({ key: '/accounting/models' }),
        //     children: [lastSeenMenu(modelLogs, 'model', 'no models'), createNewItemMenu('Model')],
        // },
        {
            key: '/menu-models',
            label: 'Models',
            popupClassName: !isOpen('/menu-models') ? 'main-nav-submenu menu-disabled' : 'main-nav-submenu menu-double',
            disabled: !isLoaded,
            onTitleClick: () => handleClick({ key: '/models' }),
            children: [
                lastSeenMenu(modelLogs, 'accounting/model', 'no models'),
                {
                    type: 'group',
                    key: `/menu-tools-models`,
                    label: (
                        <span className="submenu-title-wrapper">
                            <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />
                            Tools
                        </span>
                    ),
                    children: [
                        {
                            key: '/models',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['radar']} />
                                    Browse Models
                                </div>
                            ),
                        },
                        {
                            key: '/due',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['briefcase-arrow-right']} />
                                    Daily Engaged Talents
                                </div>
                            ),
                        },
                    ],
                },
                createNewItemMenu('Model'),
            ],
        },
        {
            key: '/menu-customers',
            label: 'Contacts',
            popupClassName: 'main-nav-submenu',
            disabled: !isLoaded,
            //onTitleClick: () => handleClick({ key: '/models' }),
            children: [
                {
                    key: '/accounting/clients',
                    label: (
                        <div className="nw-main-nav-subitems">
                            <NwNavIcon icon={byPrefixAndName.fasl['address-card']} />
                            Clients Search
                        </div>
                    ),
                },
                {
                    key: '/accounting/agencies',
                    label: (
                        <div className="nw-main-nav-subitems">
                            <NwNavIcon icon={byPrefixAndName.fasl['globe']} />
                            Agencies Search
                        </div>
                    ),
                },
                {
                    key: '/accounting/services',
                    label: (
                        <div className="nw-main-nav-subitems">
                            <NwNavIcon icon={byPrefixAndName.fasl['life-ring']} />
                            Services Search
                        </div>
                    ),
                },
            ],
        },
        // {
        //     key: '/accounting/customers',
        //     label: 'Contacts',
        //     popupClassName: 'main-nav-submenu',
        //     disabled: !isLoaded,
        //     onTitleClick: () => handleClick({ key: '/accounting/customers' }),
        //     children: [lastSeenMenu(customerLogs, 'accounting/customer', 'no contacts'), createNewItemMenu('Customer')],
        // },
        { key: '/accounting/admin/transactions', label: 'Settings', disabled: !isLoaded },
    ];

    const keysWithSubmenus = navItems.filter((item) => item.children).map((item) => item.key);

    return (
        <NavMenu
            className={getNavClassName(breakpoints, navItems.length)}
            inlineIndent={10}
            items={navItems}
            mode={getNavMenuMode(drawer, breakpoints)}
            onClick={handleClick}
            onOpenChange={(k) => handleChangeOpenKeys(k, keysWithSubmenus)}
            openKeys={openKeys}
            selectedKeys={[current]}
        />
    );
};

export default NwNavBarAccounting;
